/** 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 * Responsive sidebar focus belongs to Core and is distributed by official sync.
 */
import { useLayoutEffect, useRef } from 'react';
import { useIsMobileViewport } from './useMediaQuery';

export function useSidebarAccessibility(isOpen: boolean, isCollapsed: boolean) {
    const isMobileViewport = useIsMobileViewport();
    const sidebarRef = useRef<HTMLElement>(null);
    const toggleRef = useRef<HTMLButtonElement>(null);
    const hidden = isMobileViewport && !isOpen;

    useLayoutEffect(() => {
        const sidebar = sidebarRef.current;
        if (!sidebar) return;
        const previousInert = sidebar.inert;
        const previousAriaHidden = sidebar.getAttribute('aria-hidden');
        if (hidden && sidebar.contains(sidebar.ownerDocument.activeElement)) toggleRef.current?.focus();
        sidebar.inert = hidden;
        if (hidden) sidebar.setAttribute('aria-hidden', 'true');
        else sidebar.removeAttribute('aria-hidden');
        return () => {
            sidebar.inert = previousInert;
            if (previousAriaHidden === null) sidebar.removeAttribute('aria-hidden');
            else sidebar.setAttribute('aria-hidden', previousAriaHidden);
        };
    }); // The shell can mount after auth hydration without a viewport/state change.

    return { sidebarRef, toggleRef, isMobileViewport, hidden,
        expanded: isMobileViewport ? isOpen : !isCollapsed };
}
